/**
 * @generated SignedSource<<e8771a342651d42af5652a796e0278f9>>
 * @relayHash 4cdc89941974739daaccc097bd554c2b
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/458.0.0-2024-04-17T07:05:02.830Z/RenderPortfolioEmailsMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PortfolioShareType = "FOLDERS" | "ITEMS" | "%future added value";
export type RenderPortfolioEmailsInput = {
  captchaToken?: string | null;
  clientMutationId?: string | null;
  message?: string | null;
  portfolioIds?: ReadonlyArray<string | null> | null;
  portfolioItemIds?: ReadonlyArray<string | null> | null;
  recipientEmails: ReadonlyArray<string | null>;
  senderEmail: string;
  senderName: string;
  shareType: PortfolioShareType;
  showNotes?: boolean | null;
  userId: string;
};
export type RenderPortfolioEmailsMutation$variables = {
  input: RenderPortfolioEmailsInput;
};
export type RenderPortfolioEmailsMutation$data = {
  readonly renderPortfolioEmails: {
    readonly clientMutationId: string | null;
  } | null;
};
export type RenderPortfolioEmailsMutation = {
  response: RenderPortfolioEmailsMutation$data;
  variables: RenderPortfolioEmailsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RenderPortfolioEmailsPayload",
    "kind": "LinkedField",
    "name": "renderPortfolioEmails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RenderPortfolioEmailsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RenderPortfolioEmailsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-misc/458.0.0-2024-04-17T07:05:02.830Z/RenderPortfolioEmailsMutation",
    "metadata": {},
    "name": "RenderPortfolioEmailsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "069b090a2237485c10f337e44853ac0a";

export default node;
